import React from 'react';
import { Row } from 'react-table';
import { Quality } from '../../../../Types/LotDetailQuality';

export interface LBMLabMinMaxCellProps {
    row: Row<Quality>,
    qualityType: string
}

function LBMLabMinMaxCell({ row, qualityType }: LBMLabMinMaxCellProps): React.JSX.Element {

    const numberOfSamples = getNumberOfSamples(row);

    if (numberOfSamples && numberOfSamples <= 1) {
        return <span>-</span>;
    }

    const value = row.original.qualityValues.find(x => x.testMethod === qualityType)?.resultValue;

    return <span>{value}</span>;
}

function getNumberOfSamples(row: Row<Quality>) {
    const lbmLabQualityValue = row.original.qualityValues.find(x => x.testMethod === "LBMLABCALC");
    return lbmLabQualityValue?.qualityValueSamples.length;
}

export default LBMLabMinMaxCell;